export default __webpack_public_path__ + "static/accurate_nlp-44ac6fb50f7bde170e202c85b7520f5e.webp";